.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-title + gz-form-field, gz-title + gz-labeled-content {
  padding-top: 15px;
}

gz-chips-generator-input {
  --chip-list-width: 480px;
  --form-field-with-floating-max-width: 480px;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.title-with-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-direction: row;
  margin-top: calc(var(--spacer) * 4);
}
